import styled from "styled-components";

export const ContratosContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 40px;
  box-sizing: border-box;
  background-image: url("/textura.jpg");
  background-size: cover;
  background-attachment: fixed;
`;

export const ContentBox = styled.div`
  background: rgba(30, 30, 30, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  h2 {
    margin: 0;
    color: #e6aa3a;
    font-size: 28px;
  }
`;

export const CreateButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #e6aa3a;
  color: #111;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }
`;

export const CreateButtonWithdraw = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(40, 200, 220, 1);
  color: #111;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }
`;

export const SearchAreaContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
`;

export const FiltersRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-end;

  @media (max-width: 900px) {
    flex-wrap: wrap;
  }
`;

export const SearchClient = styled.div`
  .title {
    display: block;
    font-size: 14px;
    color: #fff;
    opacity: 0.8;
    margin-bottom: 8px;
    text-transform: uppercase;
  }
  .box {
    display: flex;
  }
  input {
    flex-grow: 1;
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 20px;
    color: #fff;
    border-radius: 6px 0 0 6px;
    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }
  button {
    width: 60px;
    height: 45px;
    border: none;
    background: #e6aa3a;
    color: #111;
    cursor: pointer;
    border-radius: 0 6px 6px 0;
  }
`;

export const FilterDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h4 {
    margin: 0;
    font-size: 14px;
    color: #fff;
    opacity: 0.8;
    text-transform: uppercase;
  }

  select {
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 15px;
    color: #fff;
    border-radius: 6px;
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead``;
export const TableRow = styled.tr`
  color: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  &:first-child {
    background-color: rgba(0, 0, 0, 0.2);
    border-bottom: 2px solid #e6aa3a;
  }
`;

export const TableHeaderCell = styled.th`
  padding: 15px;
  text-align: left;
  white-space: nowrap;
  color: #fff;
  font-weight: 600;
`;

export const TableBody = styled.tbody``;

export const VerVendaButton = styled.button`
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  background: rgba(40, 200, 220, 1);
  color: black !important;
`;

export const TableCell = styled.td`
  padding: 15px;
  text-align: left;
  white-space: nowrap;

  .buttonBox {
    display: flex;
    gap: 10px;
  }

  button {
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    color: #fff;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  gap: 15px;
  color: #fff;
`;

export const PaginationButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover:not(:disabled) {
    background: #e6aa3a;
    color: #111;
    border-color: #e6aa3a;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const HomeInitialContent = styled.div``;
export const Contracts = styled.div``;
export const ContractsTitle = styled.h2`
  margin: 0;
  color: #e6aa3a;
  font-size: 28px;
`;
export const SearchArea = styled.div``;
export const Boxes = styled.div``;
export const Box = styled.div``;
export const BoxContent = styled.div``;
export const BoxTitle = styled.h4``;

export const SaleButton = styled.button`
    background: #1abc9c; /* Verde Água */
    color: white;
    border: none;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.2s;
    text-transform: uppercase;

    &:hover {
        background: #16a085;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const Divisor = styled.div`
  display: flex;
  gap: 20px;
`;

export const ContractButton = styled.button`
    background: #3498db; /* Azul */
    color: white;
    border: none;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.2s;
    text-transform: uppercase;

    &:hover {
        background: #2980b9;
    }
`;